const s = {
  name: "Diagnostics",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M23.8,10h-2.6l-3.7,16.6L15.8,19H10v2h4.2l2,9h2.6l3.7-16.6l1.7,7.6H30v-2h-4.2L23.8,10z"/>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v34c0,1.7,1.3,3,3,3h34c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H3z M2,3c0-0.6,0.4-1,1-1h34
			c0.6,0,1,0.4,1,1v34c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V3z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Diagnostics
};
